import Api from '@/services/Api'
import ApiDownloadReporte from '@/services/Api'

const HEADERURL = 'wms/contenedor/';
const ACTION_ADD_DETAIL = 'asignar_tarima_a_contenedor';
const ACTION_DELETE_DETAIL = 'remover_tarima_a_contenedor';
const ACTION_RETORNO = 'retorno';
const ACTION_FINALIZAR_ENVIO= 'finalizar_envio';
const ACTION_FINALIZAR_CARGA= 'finalizar_carga';
const ACTION_FINALIZAR= 'finalizar';
const ACTION_REPORTE_PDF = 'pdf';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    asignar_tarima_a_contenedor(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_ADD_DETAIL}/`, params);

    },

    remover_tarima_a_contenedor(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_DELETE_DETAIL}/`, params);

    },

    finalizar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_FINALIZAR}/`);
    },


    finalizar_carga(params) {

        return Api().post(`${HEADERURL}${ACTION_FINALIZAR_CARGA}/`, params);

    },

    finalizar_envio(params) {

        return Api().post(`${HEADERURL}${ACTION_FINALIZAR_ENVIO}/`, params);

    },


    pdf(id) {

        return Api().get(`${HEADERURL}${id}/${ACTION_REPORTE_PDF}/`);

    },

    retorno(params) {

        return Api().post(`${HEADERURL}${ACTION_RETORNO}/`, params);

    },


}